import { createContext, useState } from 'react'

const SettingsContext = createContext()

export const SettingsProvider = ({ children }) => {
   const [currentTab, setCurrentTab] = useState('account')
   const [showAlert, setShowAlert] = useState(false)

   return <SettingsContext.Provider value = {{
      currentTab, 
      showAlert,
      setShowAlert,
      setCurrentTab
   }}>
      {children}
   </SettingsContext.Provider>
}

export default SettingsContext